export const BASE_TEXT_FIELD_HEIGHT = 44;
export const TEXT_ROW_HEIGHT = 14;
